var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(document,d){return _c('detail-card',{key:`${document.id}${d}`,attrs:{"medical-record-id":_vm.id,"document":document,"can-sign":_vm.canSign}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }